import MovableCoord from "./MovableCoord";

MovableCoord.VERSION = "2.0.0-rc.1";
module.exports = MovableCoord;



// WEBPACK FOOTER //
// src/index.js